<template>
	<div id="mapApp"  @click="hideMap">
		<div class="mapApp flex column">
			<div class="selectApp">
				<ul>
					<li @click="BMap">
						百度地图
					</li>
					<li @click="AMap">
						高德地图
					</li>
					<li>
						取消
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return{
				lat: null,
				lng: null,
			}
		},
		methods: {
			hideMap() {
				this.$store.state.hasMap = false;
			},
			/*调起高德地图*/
			AMap(){
				var self = this;
				var ua = navigator.userAgent.toLowerCase();
				this.lat = this.$store.state.parkLat;
				this.lng = this.$store.state.parkLng;
				if(/iphone|ipad|ipod/.test(ua)) {
					window.location.href = "iosamap://path?sourceApplication=applicationName&sid=BGVIS1&did=BGVIS2&dlat=" + this.lat + "&dlon=" + this.lng + "&dev=0&t=0"
				} else {
					window.location.href = "amapuri://route/plan/?sid=BGVIS1&did=BGVIS2&dlat=" + this.lat + "&dlon=" + this.lng + "&dev=0&t=0"
				}
			},
			
			/*调起百度地图*/
			BMap(){
				var that = this
				var ua = navigator.userAgent.toLowerCase()
				var lat = this.$store.state.parkLat
				var lng = this.$store.state.parkLng
				function bd_encrypt(gg_lng, gg_lat) {
					var X_PI = Math.PI * 3000.0 / 180.0
					var x = gg_lng,
						y = gg_lat
					var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI)
					var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI)
					var bd_lng = z * Math.cos(theta) + 0.0065
					var bd_lat = z * Math.sin(theta) + 0.006
					return {
						bd_lat: bd_lat,
						bd_lng: bd_lng
					};
				};
				var bd = bd_encrypt(lng,lat)
				if(/iphone|ipad|ipod/.test(ua)) {
					window.location.href = "baidumap://map/direction?destination=" + bd.bd_lat + "," + bd.bd_lng + "&mode=driving"
				} else {
					//打开百度地图
					window.location.href = "bdapp://map/direction?destination=" + bd.bd_lat + "," + bd.bd_lng + "&mode=driving"
				}
				
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import './mapApp.scss'
</style>